import { InfoIcon } from '../icons/InfoIcon'

export function DashboardError({
  errorMessage,
  linkHref = '/',
  linkTitle = 'Continue Shopping'
}: {
  errorMessage: string
  linkHref?: string
  linkTitle?: string
}) {
  return (
    <div className="w-100 p-4 md:p-32 flex flex-col justify-center items-center ">
      <div className="flex justify-center items-center mb-6">
        <InfoIcon className="mr-1 text-error" />
        <span className="text-error">{errorMessage}</span>
      </div>
      <a href={linkHref} className="button-primary">
        {linkTitle}
      </a>
    </div>
  )
}
